// This error message will be displayed when 'MandateColumnSet' from report interface was violated.
export const missingMandatoryColumnErrors = {
  ProductDimensionPerformanceReport: _TL_('You must select at least one attribute and performance statistic in order for the report to run. Examples of attributes are Brand or Merchant product ID. Examples of performance statistics are Clicks or Impressions.'),
  HotelDimensionPerformanceReport: _TL_('You must select at least one attribute and performance statistic in order for the report to run.'),
};
